import DrawerSimple from "ds/components/DrawerNew/Simple";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import { AnalyticsPageOrganization } from "hooks/useAnalytics/pages/organization";
import { AnalyticsPagePersonal } from "hooks/useAnalytics/pages/personal";

import ApiKeysInfoDrawerContent from "./Content";

type ApiKeysInfoDrawerProps = {
  analyticsPage: AnalyticsPageOrganization | AnalyticsPagePersonal;
};

const ApiKeysInfoDrawer = createDrawer(({ analyticsPage }: ApiKeysInfoDrawerProps) => {
  return (
    <DrawerSimple isDismissable>
      <ApiKeysInfoDrawerContent analyticsPage={analyticsPage} />
    </DrawerSimple>
  );
});

export const showApiKeysInfoDrawer = createDrawerTrigger(ApiKeysInfoDrawer);
